import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from "src/environments/environment";
import { I18nService } from "src/app/core/i18n";
import { AuthFacade } from 'src/app/domains/auth/store/facade/auth.facade';
import { Subscription } from 'rxjs';

@Component({
  selector: 'gdp-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  clicked1 = true;
  clicked2 = true;
  clicked3 = true;
  clicked4 = true; // equipment section
  closed = true;
  usernameSub: Subscription;
  username;
  hiddenCoverage: boolean = true;
  languages = environment.supportedLanguages;
  currentLang: string;

  constructor(
    private facade: AuthFacade,
    private i18n: I18nService
  ) {}

  ngOnInit() {
    this.usernameSub = this.facade.username$.subscribe(
      username => (this.username = username)
    );
    this.currentLang = this.i18n.language;
  }

  ngOnDestroy() {
    this.usernameSub.unsubscribe();
  }

  onLogout() {
    this.facade.logout();
  }

  onClick(num: number) {
    switch (num) {
      case 1:
        this.clicked1 = !this.clicked1;
        break;
      case 2:
        this.clicked2 = !this.clicked2;
        break;
      case 3:
        this.clicked3 = !this.clicked3;
        break;
      case 4:
        this.clicked4 = !this.clicked4;
        break;
    }
  }

  onClose() {
    this.closed = !this.closed;
  }

  setLanguage(locale: string) {
    this.i18n.language = locale;
    this.currentLang = locale;
  }

}
